module.exports = __webpack_public_path__ + "img/icon_partner_11.df74d297.png";